import React from 'react';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg'
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import cars01 from '../../assets/img/cars01.png';
import { useHistory, useParams } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from 'react';
import { useEffect } from 'react';
import printJS from 'print-js';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import car from '../../assets/img/car.svg';
import barcode from '../../assets/img/barcode.svg';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Logo_final from '../../assets/img/Logo_final.png';
import Barcode from "react-barcode";
import "../../Container/TitleDue/titleDue.css";
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Datetime from 'react-datetime';
import moment from 'moment';
import wrong from '../../assets/img/wrong.png';
import PageNotFound from '../FallBackUI/PageNotFound';
import DealerAction from '../DealerRedux/DealerAction';
import UrCarAction from '../Carlist/UrCarAction';
import ls from 'local-storage'
import odometer from '../../assets/img/miles.jpg';
import Pagination from 'reactjs-hooks-pagination';
import CustomPagination from '../CustomPagination/CustomPagination';
import _ from 'lodash';

const pageLimit = 2;


const TitleDue = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const successData = useSelector(state => state.LoginReducer.payload);
  const dealerData = useSelector(state => state.DealerReducer.payload);
  const [historyDetials, setHistoryDetials] = useState([]);
  const [VINNumber, setVINNumber] = useState("");
  const [year, setYear] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [vinError, setVinError] = useState("");
  const [paymentstatus, setPaymentStatus] = useState("");
  const [inventoryNo, setInventoryNo] = useState("");
  const [billOfSale, setBillOfSale] = useState("");
  const [titlestatus, setTitleStatus] = useState("");
  const [gatepassstatus, setGatePassStatus] = useState("");
  const [gatepasscode, setGatePassCode] = useState("");
  const [transportationStatus, setTranportationStatus] = useState("");
  const [carDetail, setCarDetail] = useState([]);
  const [carDetailsNew, setCarDetailsNew] = useState([]);
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(true);
  const [copySuccess, setCopySuccess] = useState('');
  const [copied, setCopied] = useState(false);
  const [scheduletodate, setScheduleToDate] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [fromDateError, setFromDateError] = useState("");
  const [selecetedItem, setSelecetedItem] = useState(null);
  const [feeDetails, setFeeDetails] = useState("");
  const [isShown, setIsShown] = useState(false);
  const [loadMore, setLoadMore] = useState(10);
  const [filterloadMore, setFilterLoadMore] = useState(10);
  const [loadMoreOrder, setLoadMoreOrder] = useState(10);
  const [loadMoreSearch, setLoadMoreSearch] = useState(10);
  const [titledueCount, setTitledueCount] = useState([]);
  const [titledueDetailsCount, setTitleDueDetailsCount] = useState(false);
  const [titleDueSearchCount, setTitleDueSearchCount] = useState("");
  const [carDetailLength, setCarDetailLength] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [carId, setCarId] = useState(null);
  const [dealerList, setDealerList] = useState("");
  const [sellerList, setSellerList] = useState("");
  const [dealerId, setDealerId] = useState("");
  const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
  const [dealername, setDealerName] = useState("");
  const [enterTitle, setEnterTitle] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [titledueExcel, setTitledueExcel] = useState([]);
  const [selectSellerId, setselectSellerid] = useState("");
  const [flagFilter, setFalgFilter] = useState(false);
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [searchFlag, setSearchFlag] = useState(false);
  const [searchFlag1, setSearchFlag1] = useState(false);

  const backUrl = ls.get("backredirection");
  console.log("check the back url", backUrl);
  const back = backUrl[(backUrl.length) - 1];
  console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

  const yesterday = moment().subtract(1, 'day');
  const disablePastDt = current => {
    return current.isAfter(scheduleDate);
  };

  const handlePages = (page) => {
    ls.set("currentpageopen", page)
    setCurrentPage(page)
    setSearchFlag1(true)
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    setSearchFlag1(true)
  };


  const gettitledue = (data) => {
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
      rowsPerPage: pageLimit,
      pageNumber: currentPage,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }

    API.post('titleDetails/condition', request).then(res => {

      if (res.data.success === true) {
        setLoading(false);
        setCarDetail(res.data.data);
        setCarDetailLength(res.data.data.length);
        let merged = []

        for (let i = 0; i < res.data.data.length; i++) {
          merged.push({
            ...res.data.data[i], ...(res.data.data1.find((item) => item.bill_of_sale_id === res.data.data[i].bill_of_sale_id))
          })
        }

        setCarDetailsNew(merged)
        setTotalPages(Math.ceil(res.data.data3[0].count / 2));
        setTotalRecords([...Array(Math.ceil(res.data.data3[0].count / 2) + 1).keys()].slice(1))

        if (res.data.data.length > 0) {

          setTitledueExcel(res.data.data.map(value => {
            return {

              model: value.model,
              make: value.make,
              year: value.year,
              vin_no: value.vin_no,
              carid: value.carid,
              billofsaleid: value.billofsaleid,
              title_status_name: value.title_status_name,
              gatepasscode: value.gatepasscode
            }
          }))
        }
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false);
      }
    });
  }

  const titleDueOrder = (data) => {
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,

      order: order,
      rowsPerPage: pageLimit,
      pageNumber: currentPage,
    }
    console.log("titleDueOrder", request)
    API.post('titleOrder/condition', request).then(res => {
      console.log("titleDueOrder response", res.data.data);
      if (res.data.success === true) {
        setCarDetail(res.data.data);

        let merged = []

        for (let i = 0; i < res.data.data.length; i++) {
          merged.push({
            ...res.data.data[i], ...(res.data.data1.find((item) => item.bill_of_sale_id === res.data.data[i].bill_of_sale_id))
          })
        }
        console.log("merged", merged);
        setCarDetailsNew(merged)
        setTotalPages(Math.ceil(res.data.data3[0].count / 2));
        setTotalRecords([...Array(Math.ceil(res.data.data3[0].count / 2) + 1).keys()].slice(1))
        // setLoadMoreOrder(res.data.data.length >= 10 ? res.data.data.length + 10 : loadMoreOrder)
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  const numberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setYear(value);
  };

  const inventoryNumberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setInventoryNo(value);
  };

  const bosNumberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setBillOfSale(value);
  };

  const searchCarDetail = (data, value) => {
    //console.log(value,"searchCarDetail");
    // setVinError("")
    setFromDateError("")

    // if (VINNumber.length > 0 && VINNumber.length < 6) {
    //   setVinError("VIN number must have last 6 digit")
    //   return;
    // }
    // else if (VINNumber.length > 6) {
    //   setVinError("VIN number accept only last 6 digit")
    //   return;
    // }
    if (scheduletodate) {
      if (!scheduleDate) {
        setFromDateError("From Date is required")
        return;
      }
    }
    if (scheduleDate) {
      if (!scheduletodate) {
        setFromDateError("To Date is required")
        return;
      }
    }
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
      //  seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,

      make: make,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      model: model,
      year: year,
      vin_no: VINNumber,
      fromdate: scheduleDate,
      todate: scheduletodate,
      // fromdate: scheduleDate == null ? "" : convert(scheduleDate),
      // todate: scheduleDate == null ? "" : scheduletodate == null ? convert(new Date()) : convert(scheduletodate),
      payment_mode: paymentstatus,
      carid: inventoryNo,
      bill_of_sale_id: billOfSale,
      title_status: titlestatus == "Select" ? "" : titlestatus,
      gatepass_status: gatepassstatus == "Select" ? "" : gatepassstatus,
      gatepass: gatepasscode,
      transportation_status: transportationStatus == "Select" ? "" : transportationStatus,
      rowsPerPage: pageLimit,
      pageNumber: value == 1 ? 1 : currentPage,
    }
    console.log("active data", request);
    API.post("titleSearch/condition", request)
      .then((res) => {
        if (res.data.success === true) {
          setTitleDueDetailsCount(res.data.data.length)
          console.log("check the title due search length", res.data.data.length)
          console.log("history details count", titledueDetailsCount)
          setCarDetail(res.data.data);

          let merged = []

          for (let i = 0; i < res.data.data.length; i++) {
            merged.push({
              ...res.data.data[i], ...(res.data.data1.find((item) => item.bill_of_sale_id === res.data.data[i].bill_of_sale_id))
            })
          }
          console.log("merged", merged);
          setCarDetailsNew(merged)
          setTotalPages(Math.ceil(res.data.data3[0].count / 2));
          setTotalRecords([...Array(Math.ceil(res.data.data3[0].count / 2) + 1).keys()].slice(1))
          setTitleDueSearchCount(res.data.titlestatus_count);
          // console.log("title_search data", res.data);
          // setLoadMoreSearch(res.data.data.length >= 10 ? res.data.data.length + 10 : loadMoreSearch)
          // setTotalRecords(res.data.titlestatus_count);
          if (res.data.data.length > 0) {
            // 
            setTitledueExcel(res.data.data.map(value => {
              return {

                model: value.model,
                make: value.make,
                year: value.year,
                vin_no: value.vin_no,
                carid: value.carid,
                billofsaleid: value.billofsaleid,
                title_status_name: value.title_status_name,
                gatepasscode: value.gatepasscode
              }
            }))
          }
        }
        else {
          setErrors(res.data.error)
          setErrorFlag(true)
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  const getFiltertitledue = (data, val) => {
    let request = {
      seller_dealer_id: data.seller_dealer_id,
      rowsPerPage: pageLimit,
      pageNumber: val == 1 ? 1 : currentPage,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }
    API.post('titleDetailsFilter/condition', request).then(res => {
      console.log("titleDueDetails response", res.data.data);
      if (res.data.success === true) {
        setCarDetail(res.data.data);

        setCarDetailLength(res.data.data.length);
        let merged = []

        for (let i = 0; i < res.data.data.length; i++) {
          merged.push({
            ...res.data.data[i], ...(res.data.data1.find((item) => item.bill_of_sale_id === res.data.data[i].bill_of_sale_id))
          })
        }
        setCarDetailsNew(merged)
        setTotalPages(Math.ceil(res.data.data3[0].count / 2));
        setTotalRecords([...Array(Math.ceil(res.data.data3[0].count / 2) + 1).keys()].slice(1))
        if (res.data.data.length > 0) {

          setTitledueExcel(res.data.data.map(value => {
            return {

              model: value.model,
              make: value.make,
              year: value.year,
              vin_no: value.vin_no,
              carid: value.carid,
              billofsaleid: value.billofsaleid,
              title_status_name: value.title_status_name,
              gatepasscode: value.gatepasscode
            }
          }))
        }
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  }

  function copytoclipboard(e) {
    document.execCommand('copy');
    e.target.focus();
    setCopySuccess('Copied!');
  };
  const carView = (item) => {
    setSelecetedItem(item);
    console.log("setSelecetedItem data", item);
  }
  useEffect(() => {
    gettitledue(dealerData);
    order !== "" && titleDueOrder(dealerData);
  }, [order, dealerData, currentPage]);

  async function fetchBuyerFees(data) {
    console.log("inside fn");
    let request = {
      type: "Seller",
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token

    };
    const state = API.post('sellerFees/condition', request);
    state.then(res => {
      console.log("res", res)
      if (res.data.success === true) {
        setFeeDetails(res.data.data);
        // setLoading(false);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  useEffect(() => {

    fetchBuyerFees(dealerData);
    // searchCarDetail()

  }, [dealerData]);


  const gettitledueLength = (data) => {
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      // key:10
    }
    console.log("titleDueDetails", request)
    API.post('countDetails/condition', request).then(res => {
      console.log("titleDueDetails response", res.data.data);
      if (res.data.success === true) {
        setTitledueCount(res.data.data);
        setTotalRecords(res.data.data.titledue_count);
        console.log("car Detail", res.data.data);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  useEffect(() => {
    gettitledueLength(dealerData);
  }, [dealerData]);


  const getFeeDetails = (price) => {
    return feeDetails.length > 0 ? feeDetails
      .filter((data) => {
        const range = data.from_price
        const rangeOne = data.to_price
        // const range = data.fee_price.replaceAll('$',"").split("-")

        if (range[1] !== "up") {

          return Number(range) <= Number(price) && Number(price) <= Number(rangeOne)
        }
        else {
          return Number(range) <= Number(price)
        }

      }

      )[0]?.fee || 0
      : 0
  }
  const togglePrint = () => {
    setIsOpen(!isOpen);
  }

  const handleSellerDetailsName = (e) => {

    setDealerId(e.target.value)
    console.log("=========check seller details name", e.target.value)
    setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
    console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
    const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
    getFiltertitledue(selectedSellerDetails, 1)
    setselectSellerid(selectedSellerDetails.seller_dealer_id)
    setFalgFilter(true)
    dispatch(DealerAction.searchrequest(selectedSellerDetails));
  }

  useEffect(() => {
    if (dealerData !== null) {

      getFiltertitledue(dealerData, 1);
    }
  }, [dealerData])

  const getDealername = (data) => {

    let request = {

      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    }
    API.post("dealerNameDynamic/condition", request).then(response => {
      if (response.data.success === true) {


        setDealerList(response.data.data);

      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  const PrintData = (item) => {


    setCarId(item.carid);
    setBillOfSale(item.bill_of_sale_id);
    setYear(item.year);
    setMake(item.make);
    setModel(item.model);
    setVINNumber(item.vin_no);
    setTitleStatus(item.title_status_name);
    setInventoryNo(item.carid);
    setGatePassCode(item.gatepass_id);




    togglePrint();
  }
  const printPage = (data) => {
    console.log("print")
    printJS({
      printable: "pdfPage",
      type: 'html',
      targetStyles: ['*'],
      header: 'Car Details'
    })
  }

  const config = {
    background: "#f5f5f5",
    displayValue: false,
    marginTop: "20px",
    marginBottom: "20px",
    fontOptions: "italic",
    width: 2,
    heigth: 5
  };
  const showDetails = (data, minusBtn, plusButton) => {
    console.log("showDetails", data)
    document.getElementById(data).setAttribute("class", "showContent");
    document.getElementById(data).removeAttribute("hideContent");

    document.getElementById(minusBtn).removeAttribute("hideContent");
    document.getElementById(minusBtn).setAttribute("class", "bx bx-minus showContent");

    document.getElementById(plusButton).removeAttribute("showContent");
    document.getElementById(plusButton).setAttribute("class", "bx bx-plus hideContent");
  }
  const hideDetails = (data, minusBtn, plusButton) => {
    console.log("hideDetails", data)
    document.getElementById(data).setAttribute("class", "hideContent");
    document.getElementById(data).removeAttribute("showContent");

    document.getElementById(minusBtn).removeAttribute("showContent");
    document.getElementById(minusBtn).setAttribute("class", "bx bx-minus hideContent");

    document.getElementById(plusButton).removeAttribute("hideContent");
    document.getElementById(plusButton).setAttribute("class", "bx bx-plus showContent");

  }
  // const loadMoreDetails = () => {

  //   if (titledueDetailsCount == false) {
  //     gettitledue(dealerData)

  //   }
  //   else {
  //     searchCarDetail(dealerData)

  //   }

  // }

  const inputProps = {
    placeholder: "YYYY-MM-DD",
    value: scheduleDate
  };
  const inputProps1 = {
    placeholder: "YYYY-MM-DD",
    value: scheduletodate
  };
  const fromDate = (event) => {
    console.log("from date", event);

    if (event._isAMomentObject == true) {
      setScheduleDate(event.format("YYYY-MM-DD"))
      setScheduleToDate("")
    }
  }
  const toDate = (event) => {
    console.log("to date", event);
    if (event._isAMomentObject == true) {
      setScheduleToDate(event.format("YYYY-MM-DD"))
    }
  }
  const getFrmDtRemove = () => {
    setScheduleDate("")
    // setScheduleToDate("")
  }
  const getToDtRemove = () => {
    setScheduleToDate("")
  }

  useEffect(() => {
    getDealername();

  }, []);

  const soldredirectpage = (pathid, seller_data, title_status_name, transportation_flag) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    // history.push("/cardetails/"+pathid);
    history.push({
      pathname: "/soldcardetails",
      state: { backURL: "/history", id: pathid, titlesold: title_status_name, transportationFlag: transportation_flag }
    });
    ls.set("backredirection", [backUrl, "/titledue"])
  }

  function formatTime(value) {
    let local = ""
    let offset = ""
    local = new Date(value);
    offset = local.getTimezoneOffset();
    value = new Date(local.getTime() - offset * 60000);
    value = moment(value).format('MMMM D, YYYY hh:mm A')
    return value;
  }

  const [carSearchTriggered, setCarSearchTriggered] = useState(false);
  console.log("rocords carSearchTriggered", carSearchTriggered, searchFlag1, searchFlag);

  const handlePageChangeDebounced = _.debounce(() => {
    if (!searchFlag1 && !searchFlag) {
      gettitledue();
    }
    else if (searchFlag1 && searchFlag && !carSearchTriggered) {
      searchCarDetail();
    } else if (searchFlag1 && !searchFlag) {
      gettitledue();
    }
  }, 300);

  useEffect(() => {
    if (searchFlag || searchFlag1) {
      setCarSearchTriggered(false);
    }
  }, [searchFlag, searchFlag1]);

  useEffect(() => {

    handlePageChangeDebounced();
    console.log("checking if in useEffect");
    return () => {
      handlePageChangeDebounced.cancel();
    };

  }, [currentPage]);
  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Title Due Report');

    // Add headers
    const headers = ['Model', 'Make', 'Year', 'VIN #', 'Inventory #', 'Bill Of Sale #', 'Title Status', 'Gate Pass Code'];
    const headerRow = worksheet.addRow(headers);

    // Style header
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }
    };

    // Add data
    titledueExcel.forEach(item => {
      worksheet.addRow([
        item.model,
        item.make,
        item.year,
        item.vin_no,
        item.carid,
        item.billofsaleid,
        item.title_status_name,
        item.gatepasscode
      ]);
    });

    // Auto-size columns
    worksheet.columns.forEach(column => {
      column.width = 20;
    });

    // Generate Excel file
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'TitleDueReport.xlsx');
    });
  };

  return (
    <div>
      {loading ? <Loading /> :
        <main id="main" class="inner-page02">

          {errorFlag === true ? <PageNotFound error={errors} /> :
            <div id="historyPage" class="historyPage titleDuePage">
              <div class="container-fluid inner-page-space" >


                <div class="common-heading">
                  <div className="row">
                    <div className="col-lg-4">
                      <div class="back-btn">
                        <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                          <i class="bx bx-chevron-left"></i> Back
                        </a>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div class="title">
                        <p class="inner-title">Title Due</p>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div class="title-dropdown">
                        <select id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
                          ? "tableRowPink  form-control box"
                          : dealerData?.color == "firered"
                            ? "tableRowFireRed  form-control box"
                            : dealerData?.color == "green"
                              ? "tableRowGreenColor form-control box"
                              : dealerData?.color == "darkred"
                                ? "tableRowRed1  form-control box"
                                : " form-control box") :
                          (dealerList[0]?.color == "pink"
                            ? "tableRowPink  form-control box"
                            : dealerList[0]?.color == "firered"
                              ? "tableRowFireRed  form-control box"
                              : dealerList[0]?.color == "green"
                                ? "tableRowGreenColor form-control box"
                                : dealerList[0]?.color == "darkred"
                                  ? "tableRowRed1  form-control box"
                                  : " form-control box")
                          }`} onChange={handleSellerDetailsName}>
                          {dealerData != null ?
                            <option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
                            <option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}
                          {dealerList.length > 0 &&
                            <>
                              {dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
                                ? "tableRowPink  user_name"
                                : dealerList?.color == "Silver"
                                  ? "tableRowSilver  user_name"
                                  : dealerList?.color == "Orange"
                                    ? "tableRowOrange  user_name"
                                    : dealerList?.color == "Navy blue"
                                      ? "tableRowNavyBlue  user_name"
                                      : dealerList?.color == "firered"
                                        ? "tableRowFireRed  user_name"
                                        : dealerList?.color == "Purple"
                                          ? "tableRowPurple  user_name"
                                          : dealerList?.color == "Yellow"
                                            ? "tableRowYellow1  user_name"
                                            : dealerList?.color == "green"
                                              ? "tableRowGreenColor user_name"
                                              : dealerList?.color == "blue"
                                                ? "tableRowBlue  user_name"
                                                : dealerList?.color == "darkred"
                                                  ? "tableRowRed1  user_name"
                                                  : dealerList?.color == "black"
                                                    ? "tableRowBlack1 user_name"
                                                    : " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
                            </>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row sub-title'>
                  <div class="col-lg-4">
                    <p>{carDetailLength} Out Of {titledueCount.titledue_count} Vehicles Title Due</p>
                  </div>
                  <div class="col-lg-4">
                  </div>
                  <div className='col-lg-4'>
                    <div class="downBtn">
                      <i class="icofont-file-pdf "></i>
                      <button className="" type="button" onClick={() => printPage()}>Download</button>
                    </div>

                    <div class="downloadBtn">
                      <div class="downBtn">
                        <i class="icofont-file-excel"></i>
                        <button  onClick={exportToExcel} style={{ textDecoration: 'none', color: 'inherit' }}>
                          Export Excel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="lotfeeblock col-lg-12">

                  <div class="row content">
                    <div class="col-lg-12 col-md-12 col-sm-12 historyblock toggleList">
                      <div class="row" >
                        <div class="searchlistform col-lg-12">
                          <div class="searchblock">
                            <div className='row'>
                              <div class="form-group col-lg-2">
                                <label class="control-label" for="location">Year</label>
                                <input class="form-control border-end-0" type="text" id="location" placeholder="Enter Car Year" value={year}
                                  onChange={numberPattern} />
                              </div>

                              <div class="form-group col-lg-2">
                                <label class="control-label" for="dealername">Make</label>
                                <input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Make"
                                  onChange={(e) => setMake(e.target.value)} />
                              </div>

                              <div class="form-group col-lg-2">
                                <label class="control-label" for="dealername">Model</label>
                                <input class="form-control border-end-0" type="text" id="dealername" placeholder="Enter Car Model"
                                  onChange={(e) => setModel(e.target.value)} />
                              </div>

                              <div class="form-group col-lg-2 ">
                                <label class="control-label" for="date">Vin #</label>
                                <input class="form-control border-end-0 " type="text" id="date" placeholder="Enter Vin Number"
                                  onChange={(e) => setVINNumber(e.target.value)} />

                              </div>

                              <div class="form-group col-lg-2">
                                <label class="control-label" for="location">Inventory #</label>
                                <input class="form-control border-end-0" type="text" id="location" placeholder="Enter Inventory #"
                                  onChange={inventoryNumberPattern} value={inventoryNo} />
                              </div>

                              <div class="form-group col-lg-2">
                                <label class="control-label" for="bos">BOS #</label>
                                <input class="form-control border-end-0" type="text" id="bos" placeholder="Enter Bos #"
                                  onChange={bosNumberPattern} value={billOfSale} />
                              </div>

                              <div class="form-group col-lg-2">
                                <label class="control-label" for="location">Gate Pass Code</label>
                                <input class="form-control border-end-0" type="text" id="location" placeholder="Enter Gate pass code"
                                  onChange={(e) => setGatePassCode(e.target.value)} />
                              </div>

                              <div className="form-group col-lg-2 dateBlock">
                                <label className="control-label" for="date">From Date</label>
                                <div className="history-date-row">
                                  <Datetime closeOnSelect={true} inputProps={inputProps} timeFormat={false} dateFormat="YYYY-MM-DD"
                                    name="Date" onChange={fromDate} id="meeting_date1" />
                                  {scheduleDate &&
                                    <img src={wrong} className="history-date-img" onClick={getFrmDtRemove} />
                                  }
                                </div>
                              </div>
                              <div className="form-group col-lg-2 dateBlock">
                                <label title=" Select From date first to proceed !" className="control-label" for="todate">To Date</label>
                                <div className="history-date-row">
                                  <Datetime closeOnSelect={true} inputProps={inputProps1} timeFormat={false} dateFormat="YYYY-MM-DD"
                                    name="Date" isValidDate={disablePastDt} onChange={toDate} id="meeting_date2" />
                                  {scheduletodate &&
                                    <img src={wrong} className="history-date-img" onClick={getToDtRemove} />
                                  }
                                </div>
                              </div>
                              <div class="form-group col-lg-2 carStatus">
                                <label class="control-label" for="dealername">Gate Pass Status</label>
                                <select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
                                  onChange={(e) => setGatePassStatus(e.target.value)}>
                                  <option value="Select" >-- Select --</option>
                                  <option value="yes">yes</option>
                                  <option value="no">no</option>
                                </select>
                              </div>
                              <div class="form-group col-lg-2 carStatus">
                                <label class="control-label" for="location">Transportation Status</label>
                                <select id="drop" placeholder="Car Status" name="dropoption" className="form-control border-end-0 csSelect"
                                  onChange={(e) => setTranportationStatus(e.target.value)}>
                                  <option value="Select">-- Select --</option>
                                  <option value="1">Car with seller</option>
                                  <option value="2">In Transit</option>
                                  <option value="3">Delivered</option>
                                </select>
                              </div>
                              <div class=" form-group col-lg-2 searchbtn">
                                <button onClick={() => { searchCarDetail(dealerData, 1); setSearchFlag(true); setCurrentPage(1) }}><i class="bx bx-search"></i></button>

                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="errorMsgBox col-lg-12">
                          <p className="form-input-error" >{vinError}</p>
                          <p className="form-input-error" >{fromDateError}</p>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 historyblock p-0">
                          <div class="hisHead">
                            {titledueDetailsCount == "" || titledueDetailsCount == null || titledueDetailsCount == undefined ? "" :
                              <p>{titledueDetailsCount}  Out Of {titleDueSearchCount} Vehicles Found</p>}
                          </div>
                          {carDetailsNew.length > 0 ? carDetailsNew.map((item, index) =>
                            <div class="toggleList">
                              <div class="lotfee-inner">

                                <div class="">
                                  <div class="car-item">
                                    <div className={`${item.enter_title ? "pickupdetailcontent" : "pickupdetailcontent red-due"}`}>
                                      <p class="billsalesno invNo"><span className="label">Inventory # :</span> {item.carid} </p>
                                      <p class="billsalesno model"><span className="label">Year Make Model :</span>{item.year} {item.make} {item.model}</p>
                                      <p class="billsalesno vinNo"><span className="label">Vin # :</span>  {item.vin_no}</p>
                                      <p class="billsalesno billOf"><span className="label">Bill Of sale # : </span> {item.bill_of_sale_id}</p>
                                      <p class="billsalesno netAmt"><span className="label">Net Amount : $</span>  {Number(item.price) - Number((item.bos_seller_fee) + Number(item.bos_car_charges) + Number(item.bos_sellerothertotalcharges) || 0)}</p>
                                      <p class="billsalesno soldDate"><span className="label">Seller Name :</span>  {item.sellerName}</p>

                                    </div>
                                  </div>
                                  <div class="toggleIcon plus">
                                    <i id={`plusButton${index}`} className='bx bx-plus showContent' onClick={() => showDetails(`showDetails${index}`, `minusButton${index}`, `plusButton${index}`)}></i>

                                    <i id={`minusButton${index}`} className="bx bx-minus hideContent " onClick={() => hideDetails(`showDetails${index}`, `minusButton${index}`, `plusButton${index}`)}></i>
                                  </div>



                                  <div id={`showDetails${index}`} className="hideContent" >
                                    <div class="lotfee-inner col-lg-12 toggleExpand">
                                      <div class="row">
                                        <div class="col-lg-5">
                                          <div class="car-item">
                                            <div class="cars-prices" >
                                              {item.bill_of_sale_id == "" || item.bill_of_sale_id == null ? <a class="cta-btns-primary">Bill Of sale #{item.bill_of_sale_id}</a> :
                                                <a class="cta-btns-primary" onClick={() => {
                                                  history.push({ pathname: "/billofsale", state: { backURL: "/titledue", BillofSale: item.bill_of_sale_id, CarId: item.car_id } });
                                                  ls.set("backredirection", [backUrl, "/titledue"]);
                                                }}>Bill Of sale # : {item.bill_of_sale_id}</a>}
                                              <p class="car-btns"> Inventory # : {/* class="billsalesno pull-right enableBtn" */} <span class='hyperlink' onClick={() => { soldredirectpage(item.carid, item, item.title_status_name, item.transportation_flag) }}> {item.carid}</span></p>
                                            </div>
                                            <div className="historyImg">
                                              <img src={item.image} class="carImg" alt="..." />
                                            </div>
                                          </div>
                                        </div>


                                        <div className='col-lg-7'>
                                          <div class="cars-content">
                                            <p class="soldDate"><span><span className="label">Sold Date : </span>{formatTime(item.sold_date)}</span></p>
                                            <h3>
                                              <a href="#"> {item.year} {item.make} {item.model}</a>
                                            </h3>
                                            <div class="km-petrol">
                                              <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
                                              <p class="details">{item.fuel_type ? <img src={gasolinePump} alt="" /> : ""}<span>{item.fuel_type === "null" || item.fuel_type === "undefined" || item.fuel_type === null || item.fuel_type === undefined || item.fuel_type === "" ? "" : item.fuel_type}</span></p>
                                            </div>


                                            <div class="vinqr">
                                              <div class="carpoints">
                                                <div className="label">VIN #</div>
                                                <div class="carpoint">
                                                  <img src={car} alt="" />
                                                  <span>{item.vin_no}</span>
                                                  <CopyToClipboard text={item.vin_no} onCopy={() => setCopied(true)} >
                                                    <span title="Copy" onClick={copytoclipboard} className="copyImg"><i class="icofont-copy"></i></span>
                                                  </CopyToClipboard>
                                                  <img id={`imgBarCode${index}`} src={barcode} alt="" onMouseEnter={() => document.getElementById(`showBarCodeDetails${index}`).setAttribute("class", "showContent qrcode")} onMouseLeave={() => document.getElementById(`showBarCodeDetails${index}`).setAttribute("class", "hideContent")} />
                                                </div>
                                              </div>
                                              <div id={`showBarCodeDetails${index}`} className="hideContent" >
                                                <Barcode value={item.vin_no} {...config} />
                                              </div>
                                            </div>

                                            <div class="title-status">
                                              <p className="title-label">Title status :<span className='tit-status1'></span>
                                                <div className={`${item?.title === "Title" ? "title-cart" : item?.title === "Title Attached" ? "titleattached-cart" : item?.title === "Bill of sale only" ? "billofsale-cart" : ""}`}>{item?.title}
                                                </div>
                                              </p>
                                            </div>


                                            <div className='insp-invoice'>
                                              <a class="cta-btns invoice" href="JavaScript:void(0)"
                                                onClick={() => history.push({
                                                  pathname: "/invoice",
                                                  state: {
                                                    backURL: "/titledue", billOfSales: item.bill_of_sale_id, gatePass: item.gatepasscode, make: item.make, model: item.model,
                                                    buyerId: item.buyer_dealer_id, price: item.price, soldDate: formatTime(item.sold_date_tz), VinNo: item.vin_no,
                                                    inventoryNo: item.carid, year: item.year, buyertax: item.buyer_tax_id, license: item.buyer_license,
                                                    // achDate: item.ach_date,
                                                    selectedValues: item,
                                                    achDate: carDetail[0].ach_date_tz == "" || carDetail[0].ach_date_tz == undefined || carDetail[0].ach_date_tz == null ? "" : formatTime(carDetail[0].ach_date_tz)
                                                  }
                                                })}>Invoice</a>
                                            </div>


                                            {item.announcement == "null" || item.announcement == null || item.announcement == "undefined" ?
                                              <p className='announcement'><span className="label">Announcement : </span>{""}</p> :
                                              <p className='announcement'><span className="label">Announcement :  {item.announcement}</span></p>}
                                            <p className="label">Delivery status : <span>{item.transportation_status_name}</span></p>
                                            {item.ach_date == "" || item.ach_date == undefined || item.ach_date == null ? <p className="label">Date of fund : <span>Not yet</span></p> :
                                              <p className="label">Date of fund : <span>{item.ach_date}</span></p>}

                                            <div class="netamount">
                                              <a class="redBtn"
                                                onClick={() => history.push({
                                                  pathname: "/invoice",
                                                  state: {
                                                    backURL: "/titledue", billOfSales: item.bill_of_sale_id, gatePass: item.gatepasscode, year: item.year, make: item.make, model: item.model, buyerId: item.buyer_dealer_id, price: item.price, soldDate: formatTime(item.sold_date_tz), VinNo: item.vin_no, inventoryNo: item.carid, achDate: carDetail[0].ach_date_tz == "" || carDetail[0].ach_date_tz == undefined || carDetail[0].ach_date_tz == null ? "" : formatTime(carDetail[0].ach_date_tz)
                                                    , selectedValues: item
                                                  }
                                                })}>Net Amount : $  {Number(item.price) - Number((item.bos_seller_fee) + Number(item.bos_car_charges) + Number(item.bos_sellerothertotalcharges) || 0)} </a>
                                            </div>

                                            <div class="vinqr">
                                              <div class="carpoints">
                                                <div class="gatepasspoint">
                                                  {item.gatepasscode === "" || item.gatepasscode === undefined || item.gatepasscode === null || item.gatepasscode === "null" ?
                                                    <a class="history-text-color">Gate Pass Code :  </a> :
                                                    <a class="history-text-color">Gate Pass Code : {item.gatepasscode} </a>
                                                  }
                                                  {item.gatepasscode === "" || item.gatepasscode === undefined || item.gatepasscode === null || item.gatepasscode === "null" ? "" :
                                                    <img id={`imgBarCode${index}`} src={barcode} alt="" onMouseEnter={() => document.getElementById(`showBarCodeDetails1${index}`).setAttribute("class", "showContent qrcode")} onMouseLeave={() => document.getElementById(`showBarCodeDetails1${index}`).setAttribute("class", "hideContent")} />
                                                  }</div>
                                              </div>
                                              <div id={`showBarCodeDetails1${index}`} className="hideContent " >
                                                <Barcode value={item.gatepasscode} {...config} />
                                              </div>
                                            </div>
                                          </div>
                                        </div>



                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                            : <p className='nodata-found'>NO DATA FOUND</p>}

                        </div>

                        <div className="col-lg-12 tablePagination d-flex justify-content-center pageul">
                          {/* <Pagination className=""
                            totalRecords={totalRecords}
                            pageLimit={pageLimit}
                            pageRangeDisplayed={1}
                            onChangePage={setCurrentPage}
                          /> */}

                          <CustomPagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} totalRecords={totalRecords} handlePages={handlePages} />


                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>}




        </main>}

      <div>
        < div class="hideContent" >
          <div id="pdfPage" style={{ "border-collapse": "collapse" }}>
            <table>
              <tr className='border-0'>



                <td class="border-0" width="100%" colspan="5">
                  <div align="left">
                    <h1>
                      <b >Seller Details</b>
                    </h1>

                  </div>
                  <div align="left">
                    <b>Seller Name</b> - {successData?.dealer_name}

                  </div>
                  <div align="left">
                    <b>Address</b> - {successData?.address}
                  </div>

                </td>

                <td align="left" class="border-0" width="50%">
                  <img src={Logo_final} ></img>

                </td>
              </tr>

            </table>
            <table>
              <thead>
                <tr>
                  <td><b>Year</b> </td>
                  <td><b>Make </b></td>
                  <td><b>Model </b></td>
                  <td><b>Vin # </b></td>
                  <td><b>Inventory NO</b> </td>
                  <td><b>Bill of sale </b></td>
                  <td><b>Gate Pass Code  </b></td>
                  <td><b>Title Status </b></td>
                  <td><b>Total Amount</b> </td>

                </tr>
              </thead>

              {carDetailsNew?.length > 0 ? carDetailsNew.map((item) =>
                <tr>



                  <td>{item.year}</td>
                  <td>{item.make}</td>
                  <td>{item.model}</td>
                  <td>{item.vin_no}</td>
                  <td>{item.carid}</td>
                  <td>{item.bill_of_sale_id}</td>
                  <td>{item.gatepasscode}</td>
                  <td>{item.title_status_name}</td>
                  <td>{Number(item.price) - Number(getFeeDetails(item.price) + Number(item.bos_car_charges) + Number(item.bos_sellerothertotalcharges))}</td>
                </tr>) : ""}

            </table>
          </div>
        </div>
      </div>

      <section id="playstoreBlock" class="playstoreBlock">
        <div class="container">


          <div class="row content">
            <div class="col-lg-12">
              <img src={appstore} />
              <img src={googleplay} />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
export default TitleDue;
